<template>
  <v-row style="justify-content: flex-end" class="mb-4 mr-1 mt-4">
    <div class="mr-1">
      <slot />
    </div>
    <v-btn color="primary" dark @click.stop="showPopup"> + Новый партнёр</v-btn>
    <v-dialog v-model="dialog" max-width="540">
      <v-card style="text-align: center; background: #f5f5f6; border-radius: 2px">
        <v-card-actions style="padding-bottom: 0">
          <v-spacer></v-spacer>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-tabs v-model="partnerTabs">
          <v-tab key="link">Реферальная ссылка</v-tab>
          <v-tab key="form">Форма приглашения</v-tab>
        </v-tabs>
        <v-tabs-items v-model="partnerTabs">
          <v-tab-item key="link">
            <v-form @submit.prevent class="pr-1 pt-3">
              <v-img class="mb-6 mx-auto" src="@/assets/img/partner.png" width="150px" height="136px"></v-img>
              <h3 class="font font--h3 mb-4">Добавляйте партнёров в команду!</h3>

              <p class="font font--p-sm mb-6">
                Приглашайте новых партнёров и ежемесячно будете<br />
                {{ `зарабатывать до ${isFL && "5,5%" || isUL && "7%"} от доходов банка, полученных` }}<br />
                с клиентов приглашённого партнёра
              </p>

              <v-row style="align-items: baseline" class="pb-8" dense>
                <v-col cols="12" sm="4" class="font--color_light"> Скопируйте ссылку:</v-col>
                <v-col cols="12" sm="8">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        v-model="reflink"
                        single-line
                        hide-details
                        dense
                        outlined
                        max-width="357"
                        class="mr-sm-8 mr-0"
                        @click="copy(reflink)"
                        @mouseout="tooltipText = 'Кликните, чтобы скопировать ссылку'"
                      ></v-text-field>
                    </template>
                    <span>{{ tooltipText }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item key="form">
            <v-form class="py-2 px-4" ref="inviteForm">
              <h3 class="text-h5 text-left mb-4 mt-4">Введите данные партнёра</h3>
              <v-row no-gutters>

                <v-col cols="12">
                  <v-text-field
                    label="Номер телефона"
                    v-model.trim="inputs.user.login"
                    v-mask="'+7(9##) ###-##-##'"
                    hint="Обязательное поле"
                    persistent-hint
                    :rules="[rules.phone, rules.required]"
                    dense
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Имя"
                    v-model.trim="inputs.profile.firstname"
                    hint="Обязательное поле"
                    persistent-hint
                    :rules="[rules.cyrillicLetters, rules.required]"
                    class="mt-3"
                    dense
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Фамилия"
                    v-model.trim="inputs.profile.surname"
                    :rules="[rules.cyrillicLetters]"
                    class="mt-3"
                    dense
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Отчество"
                    v-model.trim="inputs.profile.middlename"
                    :rules="[rules.cyrillicLetters]"
                    class="mt-3"
                    dense
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="E-mail"
                    v-model.trim="inputs.profile.email"
                    :rules="[rules.required('Введите e-mail', rules.email)]"
                    hint="Обязательное поле"
                    persistent-hint
                    class="mt-3"
                    dense
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="ИНН"
                    v-model.trim="inputs.profile.inn"
                    :rules="[rules.inn]"
                    hint="Обязательное поле"
                    persistent-hint
                    class="mt-3"
                    dense
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="inputs.profile.type"
                    label="Организационно-правовая форма"
                    :items="opf_types"
                    item-text="name"
                    item-value="value"
                    class="mt-3"
                    dense
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" v-if="isNotFL(inputs.profile.type)">
                  <v-text-field
                    label="ОГРН"
                    v-model.trim="inputs.profile.ogrn"
                    :rules="[rules.ogrn, rules.required]"
                    hint="Обязательное поле"
                    persistent-hint
                    class="mt-3"
                    dense
                  />
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="inputs.profile.reward_type"
                    label="Тип вознаграждения"
                    :items="rewardTypes"
                    item-text="name"
                    item-value="value"
                    class="mt-3"
                    dense
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" class="justify-center">
                  <v-btn
                    color="primary"
                    @click="submitInvite"
                  >
                    Пригласить
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { validateInn, validateOgrn } from "@/utils/helpers";
import { mask } from "vue-the-mask";
import { invitePartner } from "@/api/partner";
import { rewardTypes } from "@/utils/rewardTypes";
import { opf_types } from "@/utils/opfTypes";
import { UL_VALUE, IP_VALUE } from "@/utils/opfTypes";
import { email as ruleEmail } from "@/utils/rules";


export default {
  directives: { mask },
  data() {
    return {
      dialog: false,
      partnerTabs: "link",
      tooltipText: "Кликните, чтобы скопировать ссылку",
      inputs: {
        user: {
          login: "+7(9",
        },
        profile: {
          firstname: null,
          surname: null,
          middlename: null,
          email: null,
          inn: "",
          ogrn: "",
          type: null,
          reward_type: null,
        },
      },
      opf_types: [{ name: "", value: null }, ...opf_types],
      rewardTypes: [{ name: "", value: null }, ...rewardTypes],
      rules: {
        phone: (v = "+7(9") => {
          return v.replaceAll(" ", "")
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "")
            .replaceAll("+", "").length === 11 || "Введите телефон в правильном формате";
        },
        cyrillicLetters: (v) => {
          return v?.match(/[а-я-\s]/gi)?.join("") === v || !v || "Только кириллица, дефис и пробел";
        },
        required: v => !!v || "Обязательное поле",
        inn: v => validateInn(v) || "Введите валидный ИНН",
        ogrn: v => validateOgrn(v) || "Введите валидный ОГРН",
        email: ruleEmail,
      },
    };
  },
  methods: {
    submitInvite() {
      if (this.$refs.inviteForm.validate()) {
        invitePartner(this.inputs)
          .then((res) => {
            if (res) {
              this.$refs.inviteForm.reset();
              this.dialog = false;
            }
          });
      }
    },
    isNotFL(value) {
      return value === UL_VALUE || value === IP_VALUE;
    },
    copy(link) {
      if (navigator.clipboard != undefined) {
        //Chrome
        navigator.clipboard.writeText(link).then(
          function() {
          },
          function(err) {
            console.error("Не удолось скопировать ссылку ", err);
          },
        );
      } else if (window.clipboardData) {
        // Internet Explorer
        window.clipboardData.setData("Text", link);
      }
      this.tooltipText = "Скопировано";
    },
    async showPopup() {
      await this.$store.dispatch("team/getLink");
      this.dialog = true;
    },
  },
  computed: {
    ...mapState("team", ["clid"]),
    ...mapGetters("profile", ["isUL", "isFL"]),
    reflink() {
      return `${window.location.origin}/account/register?clid=${this.clid}`;
    },
  },
  beforeMount() {
    this.inputs.profile.reward_type = undefined;
    this.inputs.profile.type = undefined;
  },
};
</script>
<style scoped>
.v-tooltip__content {
  background: #464c59;
}

@media (max-width: 600px) {
  .v-card {
    min-height: 640px;
  }
}
</style>
